import React from 'react'

import { BarChart } from '@driftt/dds.reports'

import { NON_DATE_BAR_CHART_OPTIONS } from 'constants/meetings'
import useQueryConfig from 'hooks/useQueryConfig'

import { useMeetingOutcomes } from './useMeetingOutcomes.hook'

const MeetingOutcomesChart = ({ metric }) => {
  const { queryConfig } = useQueryConfig(metric)

  const { metric: data, isLoading } = useMeetingOutcomes(queryConfig)

  return (
    <BarChart
      series={data ?? []}
      isLoading={isLoading}
      orientation="column"
      stacking="normal"
      options={NON_DATE_BAR_CHART_OPTIONS}
      tooltipXValueFormat="TITLE_CASE"
    />
  )
}

export default MeetingOutcomesChart
